import { createHooksActions, createHooksSelectors } from 'src/helpers/redux'
import * as store from 'src/store/modules/storage/settings'

store.injectStore()

export * from 'src/store/modules/storage/settings'

export const useStorageSettingsSelect = createHooksSelectors<
  typeof store.selectors.selectors
>(store.selectors.selectors)

export const useStorageSettingsAction = createHooksActions<
  typeof store.actions
>(store.actions, store.selectors.communications)
